import { Site } from '@debbie/common/dist/index.js';
import { PerformedByType, } from '@debbie/common/dist/performed-by/index.js';
export const shouldShowPerformedBy = (site, performedBy) => performedBy != null &&
    (site === Site.Caseworker || performedBy.type === PerformedByType.User);
//# sourceMappingURL=visibility.js.map